import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettingsService } from '../config/config-service';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class PortfolioService {
  apiUrl: string;

  constructor( private http: CommonService,  private appSettingsService: AppSettingsService) {
    this.apiUrl = this.appSettingsService.getSettings().apiEndPoint || '';
  }

  fetchPortfolios(): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/portfolios/getAllPortfoliosforClient`);
  }
}
